import * as MutationsType from "./mutationsType";
import moment from "moment";
import { eventsCollection } from "@/config/firebase";
import requestAxios from "@/helpers/request_axios";

export default {
  async getAllEvents({ commit }, filters) {
    let reference = eventsCollection;

    if (filters) {
      if (filters.agent_id) reference = reference.where("agent_id", "==", filters.agent_id);

      if (filters.calendar_id) reference = reference.where("calendar_id", "==", filters.calendar_id);

      if (filters.team_id) reference = reference.where("team_id", "==", filters.team_id);
    }

    let events = await reference.get();
    commit(MutationsType.SET_EVENTS, []);

    if (!events.empty) {
      let allEvents = [];
      let e;

      events.forEach((event) => {
        e = { id: event.id, ...event.data() };
        e.end = e.end ?? moment(e.start).add(1, "h").toDate();
        e.timed = true;

        if (e.start === e.end) e.end = moment(e.end).add(1, "h").toDate();

        allEvents.push(e);
      });

      commit(MutationsType.SET_EVENTS, allEvents);
    }
  },
  async updateEvent({ commit }, { eventId, data }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/event/${eventId}`,
        method: "PATCH",
        data: data,
      });
      commit(MutationsType.UPDATE_EVENT, response.data.data);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  resetModuleEvent({ commit }) {
    commit(MutationsType.SET_EVENTS, null);
  },
};
